import { BreadcrumbText, NormalText } from "../partials/texts";
import globals from "../partials/global-variables";

export default {
  container: {
    display: "flex",
    flexFlow: "row wrap",
    alignItems: "center",
    "& .breadcrumbs-title": {
      ...NormalText,
      fontSize: globals.fontSize.sm,
      marginRight: "8px",
      "&:not(:empty)": {
        "&::after": {
          content: '":"'
        }
      }
    },
    "& .breadcrumbs-container": {
      display: "flex",
      flexFlow: "row wrap"
    },
    "& .breadcrumb": {
      ...BreadcrumbText,
      margin: "4px 8px 4px 0",
      padding: "5px 8px",
      background: globals.colors.gray
    }
  }
};
